import { render, staticRenderFns } from "./QRGenerator.vue?vue&type=template&id=3b35ff30"
import script from "./QRGenerator.vue?vue&type=script&lang=js"
export * from "./QRGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports